import { Field as ChakraField } from "@chakra-ui/react"
import { forwardRef } from "react"

export interface FieldProps extends Omit<ChakraField.RootProps, "label"> {
  label?: React.ReactNode
  helperText?: React.ReactNode
  errorText?: React.ReactNode
  optionalText?: React.ReactNode
  alignment?: "start" | "center"
  labelHeight?: string
}

export const Field = forwardRef<HTMLDivElement, FieldProps>(function Field(props, ref) {
  const {
    label,
    children,
    helperText,
    errorText,
    optionalText,
    alignment = "start",
    labelHeight = "30px",
    ...rest
  } = props
  return (
    <ChakraField.Root ref={ref} {...rest}>
      {label && (
        <ChakraField.Label
          height={labelHeight}
          lineHeight={"unset"}
          fontSize={"md"}
          fontWeight={"lighter"}
          alignItems={alignment}
          paddingBottom={alignment === "center" ? 1 : 0}
        >
          {label}
          <ChakraField.RequiredIndicator color="red" fallback={optionalText} />
        </ChakraField.Label>
      )}
      {children}
      {helperText && <ChakraField.HelperText>{helperText}</ChakraField.HelperText>}
      {errorText && <ChakraField.ErrorText color="red">{errorText}</ChakraField.ErrorText>}
    </ChakraField.Root>
  )
})
